var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { key: _vm.updateCardKey, staticClass: "map" },
    [
      !_vm.selectedMap
        ? _c("div", { staticClass: "no map-card" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("SelectMap")))])
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.selectedMap
        ? _c(
            "div",
            { staticClass: "map-info-container" },
            [
              _c("object-main-info", {
                attrs: {
                  fields: _vm.fields,
                  identifier: _vm.cardObjectIdentifier,
                  "identifier-label": _vm.$t("Name"),
                  "editing-data": _vm.editingData,
                  "show-edit-button":
                    !_vm.creatingMap &&
                    _vm.userHasPermission("consumable_update"),
                  "card-label": _vm.cardLabel,
                  height: _vm.cardHeight,
                  "expand-card": _vm.editingData,
                  "submit-button-label": _vm.submitButtonLabel,
                  "required-fields-filled": _vm.requiredFieldsAreFilled,
                  showEditActionButtons: ""
                },
                on: {
                  "toggle-edit": _vm.toggleEdit,
                  "save-object": _vm.saveObject,
                  "update-object": _vm.updateMap,
                  "cancel-edit": function($event) {
                    _vm.discardChangesDialogIsOpen = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.saveChangesDialogIsOpen,
          title: _vm.$t("SaveChanges"),
          content: _vm.$t("SaveChangesContent"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-content-save",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.saveObject,
          secondaryAction: function($event) {
            _vm.saveChangesDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.discardChangesDialogIsOpen,
          title: _vm.$t("DiscardChanges"),
          content: _vm.$t("ClusterCreationConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.cancelEdit,
          secondaryAction: function($event) {
            _vm.discardChangesDialogIsOpen = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23a2a0d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23a2a0d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/Maps/Map.vue
// module id = null
// module chunks = 